<script>
import * as m from '@app/paraglide/messages.js';
import {
    eventGroupState
} from '@app/store/eventGroupStore.svelte.js';
import {
    projectState
} from '@app/store/projectStore.svelte.js';
import { clearEventAudio } from '@app/lib/audio/assignEventAudio.js';
    /** @type {{eventIndex: any, property?: string, label?: string, minValue?: number, maxValue?: number, stepValue?: number, unit?: string, clearsAudio?: boolean, disabled?: boolean}} */
    let {
        event,
        property = "rate",
        label = "Rate",
        minValue = 0.5,
        maxValue = 1.5,
        stepValue = 0.01,
        unit = "x",
        clearsAudio = true,
        disabled = false
    } = $props();

function resetSlider(){
    if (disabled) {
        return;
    }

    event[property] = unit === "x" ? 1.00 : 50;
}

function handleSliderChange(){
    if (disabled || !clearsAudio) {
        return;
    }
    // Slider edits invalidate any cached audio (and waveform peaks) for this event.
    clearEventAudio(event);
}
</script>

<div class="mb-2">
    <input id="slider-input-{property}" aria-label={m.input_slider_aria_label({label})} class="w-100" ondblclick={resetSlider} type="range" bind:value={event[property]} min={minValue} max={maxValue} step={stepValue} onchange={handleSliderChange} {disabled}>
    <p class="text-dark small slider-label">{label} {event[property]}{unit}</p>
</div>

<style lang="css">
.small {
    font-size: 11px;
}

.slider-label {
    margin: -5px 0;
}
</style>
